export default __webpack_public_path__ + "static/media/trans_body.62533458.png";